import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { ManageCampaignKirsService } from '../../service/manage-campaign-kirs.service';
import { ManageCampaignsKirsActions } from './manage-campaigns-kirs.actions';
import { of } from 'rxjs';


@Injectable()
export class ManageCampaignsKirsEffects {
  loadLegalEntities$ = createEffect(
    (as: ManageCampaignKirsService = inject(ManageCampaignKirsService)) => {
      return this.actions$.pipe(
        ofType(ManageCampaignsKirsActions.loadLegalEntities),
        concatMap(({ campaignId, parameters }) =>
          as.getLegalEntitiesConfermanceGias(campaignId, parameters).pipe(
            map((manageCampaigns) =>
              ManageCampaignsKirsActions.loadLegalEntitiesSuccess({
                manageCampaigns
              })
            ),
            catchError((error) =>
              of(ManageCampaignsKirsActions.loadLegalEntitiesFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  loadAllLegalEntities$ = createEffect(
    (as: ManageCampaignKirsService = inject(ManageCampaignKirsService)) => {
      return this.actions$.pipe(
        ofType(ManageCampaignsKirsActions.loadAllLegalEntities),
        concatMap(({ campaignId, parameters }) =>
          as.getLegalEntitiesConfermanceGias(campaignId, parameters).pipe(
            map((manageCampaigns) =>
              ManageCampaignsKirsActions.loadAllLegalEntitiesSuccess({
                manageCampaigns
              })
            ),
            catchError((error) =>
              of(ManageCampaignsKirsActions.loadAllLegalEntitiesFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  loadAllLegalEntitiesFiltered$ = createEffect(
    (as: ManageCampaignKirsService = inject(ManageCampaignKirsService)) => {
      return this.actions$.pipe(
        ofType(ManageCampaignsKirsActions.loadAllLegalEntitiesFiltered),
        concatMap(({ campaignId, parameters }) =>
          as.getLegalEntitiesConfermanceGias(campaignId, parameters).pipe(
            map((manageCampaigns) =>
              ManageCampaignsKirsActions.loadAllLegalEntitiesFilteredSuccess({
                manageCampaigns
              })
            ),
            catchError((error) =>
              of(ManageCampaignsKirsActions.loadAllLegalEntitiesFilteredFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );



  constructor(private actions$: Actions) { }
}
